/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AdvancedKeywordSearchResponseDto } from '../../models/advanced-keyword-search-response-dto';

export interface GetProfileIndexKeywordValues$Params {
  programPeriodId: string;
  keyword: string;
}

export function getProfileIndexKeywordValues(
  http: HttpClient,
  rootUrl: string,
  params: GetProfileIndexKeywordValues$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<AdvancedKeywordSearchResponseDto>> {
  const rb = new RequestBuilder(rootUrl, getProfileIndexKeywordValues.PATH, 'get');
  if (params) {
    rb.path('programPeriodId', params.programPeriodId, {});
    rb.path('keyword', params.keyword, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AdvancedKeywordSearchResponseDto>;
    })
  );
}

getProfileIndexKeywordValues.PATH = '/data-mart/advanced-search/{programPeriodId}/keyword/{keyword}/profile';
